import { render, staticRenderFns } from "./OfferDiscounts.vue?vue&type=template&id=326f089f"
import script from "./OfferDiscounts.vue?vue&type=script&lang=ts"
export * from "./OfferDiscounts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports